import Paragraph from "components/elements/Paragraph";
import useTrans from "components/hooks/useTrans";
import Text from "components/typography/Text";

type Props = {
    categories: string[];
    activeCategory: string;
    setActiveCategory: any;
};

export default function IntegrationsCategories(props: Props) {
    const { categories, activeCategory, setActiveCategory } = props;
    const { t } = useTrans();
    return (
        <div className="sm:box sm:col-start-1 sm:col-end-4 sm:space-x-8 sm:space-y-8">
            <div>
                <div className={'flex flex-col'}>
                    <Paragraph
                        size={'small'}
                        fontWeight={'medium'}
                        color={'purple-dark'}
                        className={'opacity-60 mb-2 uppercase'}
                    >
                        <span>{t('categories').toUpperCase()}</span>
                    </Paragraph>
                    <div
                        className={'flex flex-row sm:flex sm:flex-col overflow-x-scroll space-x-5 mb-4 pb-2 sm:space-x-0'}
                    >
                        {categories.map((c: string, index: number) => {
                            return (
                                <div
                                    key={c + index}
                                    className={'py-2 rounded cursor-pointer transition min-w-max'}
                                    onClick={() => setActiveCategory(activeCategory == c ? '' : c)}
                                >
                                    <Text color={activeCategory == c ? "text-primary-600" : "text-primary-900"} weight={"normal"}>
                                        {c}
                                    </Text>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}